<template>
  <div class="row mt-2">
    <div class="col">
      <z-tabs v-model="currentLocationTab" :tabs="locationTabs" @change="setLocationTab" />
      <div v-if="currentLocationTab === 'Basic'" class="row p-2">
        <div class="col">
          <location-basic ref="basic" :parent="firm" :is-add="isAdd" @changed="changed" @moved="movedLocation" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Users'" class="row p-2">
        <div class="col">
          <p>The following are those users associated with this location (and any decendent locations).</p>
          <user-listing ref="users" :firm="firm" :show-firm="showFirm" :show-title="false" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Contact'" class="row p-2">
        <div class="col">
          <p>Use the following to supply this location's address, phone, and email information.</p>
          <p>For Mobile Copilot, it is important you, at least, set the Address of this location if it is a Center or a
            Shop.</p>
          <contact-info :record="firm" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'App Config'" class="row p-2">
        <div class="col">
          <location-apps ref="apps" @changed="changed" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Apps'" class="row p-2">
        <div class="col">
          <location-export />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Serving'" class="row p-2">
        <div v-if="isProvider" class="col">
          <location-provider ref="providerMembership" :firm="firm" @changed="changed" />
        </div>
        <div v-else class="col">
          <network-tree ref="locations" :firm="firm" @changed="changed" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Served By'" class="row p-2 mt-2">
        <div class="col">
          <location-served-by ref="servedBy" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Insurance'" class="row p-2 mt-2">
        <div class="col">
          <location-insurance ref="insurance" :firm="firm" @changed="changed" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Storage'" class="row p-2 mt-2">
        <div class="col">
          <location-wasabi />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Provider Notifications'" class="row p-2 mt-2">
        <div class="col">
          <location-notification :firm="firm" @changed="changed" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'CCC Registration'" class="row p-2 mt-2">
        <div class="col">
          <ccc-registrations :firm="firm" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Membership'" class="row p-2 mt-2">
        <div class="col">
          <member-listing ref="membership" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Log'" class="row p-2 mt-2">
        <div class="col">
          <review-log ref="reviewLog" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Statistics'" class="row p-2 mt-2">
        <div class="col">
          <location-stats ref="stats" />
        </div>
      </div>
      <div v-if="currentLocationTab === 'Configuration'" class="row p-2 mt-2">
        <div class="col">
          <location-configuration ref="configuration" @changed="changed" />
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <span># {{ id }}</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { lookupStore } from '@/stores/lookup'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import LocationBasic from './LocationBasic.vue'
import LocationNotification from './LocationNotification.vue'
import LocationApps from './LocationApps.vue'
import LocationExport from './LocationExport.vue'
import LocationServedBy from './LocationServedBy.vue'
import UserListing from '@/components/users/UserListing.vue'
import NetworkTree from './NetworkTree.vue'
import ContactInfo from '@/components/contact/listings/ContactInfo.vue'
import ReviewLog from './ReviewLog.vue'
import LocationInsurance from './LocationInsurance.vue'
import LocationConfiguration from './LocationConfiguration.vue'
import MemberListing from './MemberListing.vue'
import LocationProvider from './LocationProvider.vue'
import LocationWasabi from './LocationWasabi.vue'
import LocationStats from './LocationStats.vue'
import CccRegistrations from '@/components/tools/CccRegistrations.vue'
export default {
  name: 'LocationHost',
  components: {
    ZTabs,
    LocationBasic,
    LocationNotification,
    LocationApps,
    LocationExport,
    LocationServedBy,
    UserListing,
    NetworkTree,
    ContactInfo,
    ReviewLog,
    LocationInsurance,
    LocationConfiguration,
    LocationProvider,
    MemberListing,
    LocationWasabi,
    LocationStats,
    CccRegistrations
  },
  props: {
    firm: Object,
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSave: false,
      currentLocationTab: 'Basic',
      message: null,
      isLocationChanged: false
    }
  },
  async mounted() {
    this.emitter.on('firm-contact-changed', (data) => {
      console.log('Location Host set save', data)
      this.isSave = true
      this.$emit('save')
    })
    this.currentLocationTab = 'Basic'
    await this.init()
  },
  emits: ['save', 'saved', 'moved'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['location', 'apps']),
    isSuperAdmin() {
      // Matches LocationBasic: role 1 only, and the same bar the API applies.
      return this.profile?.roles?.length ? [1].includes(this.profile.roles[0]) : false
    },
    isAdmin() {
      let _is = false
      if ([1, 2, 3, 5].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    id() {
      let _id = null
      if (this.firm) {
        _id = this.firm.id
      }
      return _id
    },
    firmType() {
      let _data = null
      if (this.firm) {
        _data = this.firm.type
      }
      return _data
    },
    isPartner() {
      let _is = false
      if (this.location) {
        if (this.location.firmClass === 1) {
          _is = true
        }
      }
      return _is
    },
    isInsurance() {
      let _is = false
      if (this.location) {
        if (this.location.firmClass === 2) {
          _is = true
        }
      }
      return _is
    },
    isProviderGroup() {
      let _is = false
      if (this.location) {
        if (this.location.firmClass === 4) {
          _is = true
        }
      }
      return _is
    },
    isProviderGroup() {
      // FirmClass 4 = 'Provider Group'. The firm that owns the API integration
      // for every service location beneath it.
      return this.location?.firmClass === 4
    },
    isProvider() {
      let _is = false
      if (this.location) {
        if (this.location.firmClass === 5) {
          _is = true
        }
      }
      return _is
    },
    isCalCopilot() {
      let _is = false
      if (this.location) {
        if (this.location.firmType === 6 && this.location.isCalCopilot) {
          _is = true
        }
      }
      return _is
    },
    isADAS() {
      let _is = false
      if (this.location) {
        if (this.location.firmType === 7 && this.location.isADAS) {
          _is = true
        }
      }
      return _is
    },
    isShop() {
      let _is = false
      if (this.location) {
        if (this.location.firmType === 7) {
          _is = true
        }
      }
      return _is
    },
    locationTabs() {
      let _tabs = ['Basic']
      if (!this.isAdd) {
        _tabs.push('Users')
        _tabs.push('Contact')
        if (this.firmType === 'Admin' && this.isAdmin) {
          _tabs.push('App Config')
          _tabs.push('Log')
          _tabs.push('Statistics')
        } else {
          if (this.isProvider) {
            _tabs.push('Apps')
            _tabs.push('Serving')
          } else if (this.isInsurance) {
            _tabs.push('Configuration')
            _tabs.push('Membership')
            // _tabs.push('Apps')
          } else {
            _tabs.push('Apps')
          }
        }
        if (!this.isProvider && this.isCalCopilot && !this.isShop) {
          _tabs.push('Serving')
        }
        if (this.isShop && !this.isPartner) {
          _tabs.push('Served By')
          _tabs.push('Insurance')
        }
        if (this.isCalCopilot || this.isADAS) {
          _tabs.push('Storage')
          // Add CCC Registration tab for non-prod environments
          const env = window.config ? window.config.environment : 'prod'
          if (env !== 'prod') {
            _tabs.push('CCC Registration')
          }
        }
      }
      /*
         PROVIDER NOTIFICATIONS SITS ALONGSIDE THE OTHER LOCATION TABS, not inside
         the Provider section, because the endpoint belongs to a Provider Group
         rather than to the Service Provider locations shops actually opt in to.

         SHOWN ON PROVIDER GROUPS ONLY (FirmClass 4), matching the enqueue: it
         resolves an opted-in location up to its group and reads the registration
         from there, so a URL saved anywhere else is stored and never used. Offering
         the tab where it cannot work invites exactly that mistake.

         System administrators only, matching the endpoints behind it -- anyone
         else would find a form that answers 403 on save.
      */
      if (!this.isAdd && this.isSuperAdmin && this.isProviderGroup) {
        _tabs.push('Provider Notifications')
      }
      return _tabs
    },
    showFirm() {
      let _show = null
      if (this.firm) {
        _show = {
          firm: this.firm.id,
          user: null
        }
      }
      return _show
    }
  },
  methods: {
    ...mapActions(locationStore, [
      'saveLocation',
      'getServedBy',
      'getServedMembers',
      'getLog',
      'getMembership',
      'getPreferences',
      'getLocationApps',
      'getWasabiAccount'
    ]),
    ...mapActions(lookupStore, ['getInsurance']),
    async init(firmId = null) {
      this.isSave = false
      this.currentLocationTab = 'Basic'
      const id = firmId || (this.firm && this.firm.id)
      if (id) {
        // Issue 622: load all preference categories (General + Provider) for the Basic tab.
        await this.getPreferences({
          firm: id
        })
      }
    },
    changed(is) {
      this.isLocationChanged = is
      this.isSave = true
      this.$emit('save')
    },
    async setLocationTab(value) {
      let proceed = true
      if (this.isSave) {
        proceed = await this.save()
      }
      if (proceed) {
        this.currentLocationTab = value
        if (value === 'Basic') {
          // Issue 622: load all preference categories (General + Provider) for the Basic tab.
          await this.getPreferences({
            firm: this.firm.id
          })
        } else if (value === 'Users') {
          if (this.$refs.users) {
            this.$refs.users.search(1, null)
          }
        } else if (value === 'Served By') {
          await this.getServedBy(this.firm.id)
          await this.getServedMembers(this.firm.id)
        } else if (value === 'App Config') {
          await this.getLocationApps({
            id: this.location.firm,
            dir: 2
          })
          console.log('Apps', this.apps)
        } else if (value === 'Insurance' || value === 'Providers') {
          if (this.isProviderGroup) {
            await this.getLocationApps({
              id: this.location.firm,
              dir: 4
            })
            console.log('Apps', this.apps)
          }
          await this.getMembership(this.firm.id)
        } else if (value === 'Configuration') {
          await this.getPreferences({
            firm: this.firm.id,
            category: 'General'
          })
          await this.getInsurance()
        } else if (value === 'Log') {
          let data = {
            startDate: null,
            endDate: null,
            firm: this.firm.id
          }
          await this.getLog(data)
        } else if (value === 'Storage') {
          await this.getWasabiAccount(this.location.firm)
        }
      }
    },
    movedLocation(data) {
      this.$emit('moved', data)
    },
    async save() {
      let proceed = true
      this.message = null
      if (this.isSave) {
        console.log('Saving Location', this.currentLocationTab)
        let response = null
        if (this.currentLocationTab === 'Basic') {
          response = await this.$refs.basic.save()
        } else if (this.currentLocationTab === 'App Config') {
          response = await this.$refs.apps.save()
        } else if (this.currentLocationTab === 'Contact') {
          console.log('Saving contact info')
        } else if (this.currentLocationTab === 'Serving') {
          if (this.isProvider) {
            response = await this.$refs.providerMembership.save()
          } else {
            response = await this.$refs.locations.save()
          }
        } else if (this.currentLocationTab === 'Insurance') {
          response = await this.$refs.insurance.save()
        } else if (this.currentLocationTab === 'Configuration') {
          response = await this.$refs.configuration.save()
        } else if (this.currentLocationTab === 'Users') {
          if (this.isSave) {
            let result = await this.saveLocation()
            if (result !== undefined && result !== null) {
              response = {
                valid: true,
                msg: null
              }
            } else {
              response = {
                valid: false,
                msg: 'Location User save failed.'
              }
            }
          }
        }
        if (response) {
          if (response.valid) {
            this.isSave = false
            this.$emit('saved', this.isLocationChanged)
            this.isLocationChanged = false
          } else {
            proceed = false
            this.message = response.msg
          }
        } else {
          proceed = false
          this.message = 'Save Failed'
        }
      }
      return proceed
    }
  },
  beforeUnmount() {
    this.emitter.off('firm-contact-changed')
  }
}
</script>
<style lang="scss" scoped>
.custom-subtitle {
  font-style: italic;
  margin-left: 10px;
}
</style>
